var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_4401",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_4401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4846 20.1539L13.2231 13.8924C12.7231 14.318 12.1481 14.6475 11.4981 14.8808C10.8481 15.1142 10.1949 15.2308 9.53845 15.2308C7.93679 15.2308 6.58124 14.6764 5.47183 13.5676C4.36239 12.4588 3.80768 11.104 3.80768 9.50319C3.80768 7.90239 4.36209 6.54654 5.4709 5.43564C6.57972 4.32474 7.93453 3.76929 9.53533 3.76929C11.1361 3.76929 12.492 4.324 13.6029 5.43341C14.7138 6.54283 15.2692 7.89838 15.2692 9.50006C15.2692 10.1949 15.1462 10.8674 14.9 11.5174C14.6539 12.1674 14.3308 12.7231 13.9308 13.1847L20.1923 19.4462L19.4846 20.1539ZM9.53845 14.2308C10.8654 14.2308 11.9856 13.7741 12.899 12.8606C13.8125 11.9472 14.2692 10.827 14.2692 9.50006C14.2692 8.17315 13.8125 7.05296 12.899 6.13949C11.9856 5.22602 10.8654 4.76929 9.53845 4.76929C8.21154 4.76929 7.09134 5.22602 6.17788 6.13949C5.26443 7.05296 4.8077 8.17315 4.8077 9.50006C4.8077 10.827 5.26443 11.9472 6.17788 12.8606C7.09134 13.7741 8.21154 14.2308 9.53845 14.2308Z",
    fill: "#0A1419"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ab7e74072c2f7e2700c5cebd5c09282f.svg";
export { ForwardRef as ReactComponent };